import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import type { AppMode } from '@bmkg/core';
import { AppShell } from './components/AppShell';
import { HomePage } from './pages/HomePage';

/**
 * Halaman bandel diejeksa dinamis (spec CP12: anggaran bundle awal). Shell +
 * router tetap di chunk awal; setiap halaman menjadi chunk sendiri dan
 * dimuat saat di-singgah. Dashboard sendiri bertahap dua lapis: halaman
 * dashboard lalu chunk peta (lihat `pages/HomePage` + `modules/map/MapView`).
 */
const LaporPage = lazy(() => import('./pages/LaporPage').then((m) => ({ default: m.LaporPage })));
const LaporanDetailPage = lazy(() =>
  import('./pages/LaporanDetailPage').then((m) => ({ default: m.LaporanDetailPage })),
);
const EdukasiPage = lazy(() =>
  import('./pages/EdukasiPage').then((m) => ({ default: m.EdukasiPage })),
);
const ModulePage = lazy(() =>
  import('./pages/ModulePage').then((m) => ({ default: m.ModulePage })),
);
const QuizPage = lazy(() => import('./pages/QuizPage').then((m) => ({ default: m.QuizPage })));
const PanduanPage = lazy(() =>
  import('./pages/PanduanPage').then((m) => ({ default: m.PanduanPage })),
);
const VerifikasiPage = lazy(() =>
  import('./pages/VerifikasiPage').then((m) => ({ default: m.VerifikasiPage })),
);
const AdminPage = lazy(() => import('./pages/AdminPage').then((m) => ({ default: m.AdminPage })));
const AdminLoginPage = lazy(() =>
  import('./pages/AdminLoginPage').then((m) => ({ default: m.AdminLoginPage })),
);
const PrivasiPage = lazy(() =>
  import('./pages/PrivasiPage').then((m) => ({ default: m.PrivasiPage })),
);
const SyaratPage = lazy(() =>
  import('./pages/SyaratPage').then((m) => ({ default: m.SyaratPage })),
);

interface AppProps {
  mode?: AppMode;
}

/** Fallback suspense tanpa data palsu (ui-context: gerak releng — status teks). */
function RouteLoading() {
  return (
    <p role="status" className="route-loading">
      Memuat halaman…
    </p>
  );
}

export function App({ mode }: AppProps) {
  const resolved: AppMode = mode ?? 'community';

  return (
    <AppShell mode={resolved}>
      <Suspense fallback={<RouteLoading />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/lapor" element={<LaporPage />} />
          <Route path="/laporan/:id" element={<LaporanDetailPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/masuk" element={<AdminLoginPage />} />
          <Route path="/edukasi" element={<EdukasiPage />} />
          <Route path="/edukasi/:hazard" element={<ModulePage />} />
          <Route path="/edukasi/:hazard/kuis" element={<QuizPage />} />
          <Route path="/panduan" element={<PanduanPage />} />
          <Route path="/verifikasi/:id" element={<VerifikasiPage />} />
          <Route path="/privasi" element={<PrivasiPage />} />
          <Route path="/syarat" element={<SyaratPage />} />
        </Routes>
      </Suspense>
    </AppShell>
  );
}
